import { render } from "./EditAgency.vue?vue&type=template&id=1e474843&scoped=true&ts=true"
import script from "./EditAgency.vue?vue&type=script&lang=ts"
export * from "./EditAgency.vue?vue&type=script&lang=ts"

import "./EditAgency.vue?vue&type=style&index=0&id=1e474843&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e474843"]])

export default __exports__